import * as PopoverPrimitive from '@radix-ui/react-popover';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';
import { cn } from '../../lib/utils';

/**
 * Popover — nền cho `<DatePicker>` và mọi panel nổi khác.
 *
 * ## Vì sao dùng Radix chứ không tự dựng
 *
 * Repo tự viết những thứ **thuần tính toán** (xem `features/gantt/scale.ts`:
 * một phép nhân tuyến tính không đáng kéo cả d3 vào). Popover thì ngược lại —
 * phần khó không phải vẽ cái hộp mà là: đặt nó không tràn viewport, bẫy tiêu
 * điểm, trả tiêu điểm về đúng nút khi đóng, đóng bằng Escape, và **không** đóng
 * khi người dùng bấm vào chính nó. Đó là danh sách mà mọi bản tự viết đều làm
 * thiếu một hai mục, và mục thiếu luôn là mục người dùng bàn phím cần.
 *
 * Chuyển động khai bằng keyframes trong `styles/index.css`, không kéo thêm
 * `tailwindcss-animate` — theo đúng nếp của `.replay-*` và `.tour-*` ở đó.
 */
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export const PopoverContent = forwardRef<
  ElementRef<typeof PopoverPrimitive.Content>,
  ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'start', sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'popover-panel glass-popup-sm z-50 rounded-DEFAULT border border-border bg-card p-3 text-foreground shadow-lg outline-none',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = 'PopoverContent';
